import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import CurdTokenervice from './../../services/axios/CurdTokenervice'
import { setMessage } from './message'

export const getLessonVistis = createAsyncThunk('lessonVisits/getLessonVisits', async (arg, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    const { token, studentId, subjectId, termId } = arg

    try {
        const res = await CurdTokenervice.getLessonVisits(
            token,
            "lesson-visits",
            studentId,
            subjectId,
            termId)

        thunkAPI.dispatch(setMessage(res.data.message || 'تم تحميل زيارات الدروس'))
        return res.data
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'حدث خطأ'
        thunkAPI.dispatch(setMessage(message))
        return rejectWithValue(message)
    }
})

// Add Visit
export const addLessonVisit = createAsyncThunk(
    'lessonVisits/addLessonVisit',
    async (arg, thunkAPI) => {
        const { rejectWithValue } = thunkAPI
        const { token, studentId, subjectId, termId, courseId } = arg
        const visitData = { studentId, subjectId, termId, courseId }
        try {
            const res = await CurdTokenervice.create(token, 'lesson-visits', visitData)
            thunkAPI.dispatch(setMessage(res.data.message || 'تمت إضافة الزيارة بنجاح'))
            return res.data
        } catch (error) {
            const message = error.response?.data?.message || error.message
            thunkAPI.dispatch(setMessage(message))
            return rejectWithValue(message)
        }
    }
);

// Delete Vistits
export const deleteLessonVisit = createAsyncThunk(
    'lessonVisits/deleteLessonVisit',
    async (arg, thunkAPI) => {

        const { rejectWithValue } = thunkAPI
        const { token, studentId, subjectId, termId } = arg
        try {
            const res = await CurdTokenervice.deleteLessonVisits(
                token,
                "lesson-visits/reset",
                studentId,
                subjectId,
                termId
            )
            thunkAPI.dispatch(setMessage(res.data.message || 'تم حذف الزيارة بنجاح'))
            return res.data
        } catch (error) {
            const message = error.response?.data?.message || error.message
            thunkAPI.dispatch(setMessage(message))
            return rejectWithValue(message)
        }
    }
)



// slice
const lessonVisits = createSlice({
    name: 'lessonVisits',
    initialState: {
        visits: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getLessonVistis.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(getLessonVistis.fulfilled, (state, action) => {
                state.isLoading = false
                state.visits = action.payload
            })
            .addCase(getLessonVistis.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
            // ADD
            .addCase(addLessonVisit.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(addLessonVisit.fulfilled, (state, action) => {
                state.isLoading = false
                state.visits.push(action.payload) // إضافة مباشرة
            })
            .addCase(addLessonVisit.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })

            // DELETE
            .addCase(deleteLessonVisit.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(deleteLessonVisit.fulfilled, (state, action) => {
                state.isLoading = false
                // تحديث القائمة يدويًا لو محتاج تحذف من الواجهة
                const { studentId, subjectId, termId, courseId } = action.meta.arg
                state.visits = state.visits.filter(
                    (v) =>
                        !(
                            v.student_id === studentId &&
                            v.subject_id === subjectId &&
                            v.term_id === termId &&
                            v.course_id === courseId
                        )
                )
            })
            .addCase(deleteLessonVisit.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
    },
})

export default lessonVisits.reducer
